const ENV = process.env.REACT_APP_BUILD_ENV || 'noprofile';
console.log(ENV)
const configs = {
    noprofile: {
        SRV_BASE_URL: 'http://localhost:8080',
        OAUTH2_REDIRECT_URI: 'http://localhost:8081/oauth2/redirect',
        CHECKOUT_REDIRECT_URI: 'http://localhost:8081/checkout/complete',
        VIVA_VIEW_TRANSACTION: 'https://demo.vivapayments.com',
    },
    local: {
        SRV_BASE_URL: 'http://api.timologiclocal.gr',
        OAUTH2_REDIRECT_URI: 'http://app.timologiclocal.gr/oauth2/redirect',
        CHECKOUT_REDIRECT_URI: 'http://app.timologiclocal.gr/checkout/complete',
        VIVA_VIEW_TRANSACTION: 'https://demo.vivapayments.com',
    },
    development: {
        SRV_BASE_URL: 'https://devapi.timologic.gr',
        OAUTH2_REDIRECT_URI: 'https://dev.timologic.gr/oauth2/redirect',
        CHECKOUT_REDIRECT_URI: 'https://dev.timologic.gr/checkout/complete',
        VIVA_VIEW_TRANSACTION: 'https://demo.vivapayments.com',
    },
    production: {
        SRV_BASE_URL: 'https://api.timologic.gr',
        OAUTH2_REDIRECT_URI: 'https://app.timologic.gr/oauth2/redirect',
        CHECKOUT_REDIRECT_URI: 'https://app.timologic.gr/checkout/complete',
        VIVA_VIEW_TRANSACTION: 'https://www.vivapayments.com',
    },
};

const c = configs[ENV] ?? configs.local;

export const SRV_BASE_URL = c.SRV_BASE_URL;
export const API_BASE_URL = c.SRV_BASE_URL + '/api';
export const OAUTH2_REDIRECT_URI = c.OAUTH2_REDIRECT_URI;
export const CHECKOUT_REDIRECT_URI = c.CHECKOUT_REDIRECT_URI;
export const VIVA_VIEW_TRANSACTION = c.VIVA_VIEW_TRANSACTION;

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_KEY;

export const ACCESS_TOKEN = 'accessToken';
export const SPECIAL_ENGLISH_AFFILIATE = 43;

export const GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = API_BASE_URL + '/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const APPLE_AUTH_URL = API_BASE_URL + '/apple/oauth2/authorize?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL = API_BASE_URL + '/oauth2/authorize/github?redirect_uri=' + OAUTH2_REDIRECT_URI;
